import { useTranslation } from "react-i18next";
import { Link } from "wouter";

export default function LegalFooter() {
  const { t } = useTranslation();

  const FOOTER_COLUMNS = [
    {
      title: t("footer.product"),
      links: [
        { href: "/", label: t("footer.home") },
        { href: "/pricing", label: t("footer.pricing") },
        { href: "/changelog", label: t("footer.changelog") },
        { href: "/pricing#faq", label: t("footer.faq") },
      ],
    },
    {
      title: t("footer.legal"),
      links: [
        { href: "/legal/mentions", label: t("footer.legal_mentions") },
        { href: "/legal/cgu", label: t("footer.cgu") },
        { href: "/legal/cgv", label: t("footer.cgv") },
        { href: "/legal/confidentialite", label: t("footer.confidentiality") },
        { href: "/legal/cookies", label: t("footer.cookies") },
        { href: "/legal/remboursement", label: t("footer.reimbursement") },
        { href: "/legal/dpa", label: t("footer.dpa") },
      ],
    },
    {
      title: t("footer.support"),
      links: [
        { href: "/contact", label: t("footer.contact") },
        { href: "/pricing#faq", label: t("footer.frequent_questions") },
        { href: "/sign-in", label: t("footer.sign_in") },
        { href: "/sign-up", label: t("footer.sign_up") },
      ],
    },
  ];

  return (
    <footer className="border-t bg-background text-sm text-muted-foreground">
      <div className="mx-auto max-w-6xl px-6 py-10 flex flex-col gap-8">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 text-xs">
          {FOOTER_COLUMNS.map((col) => (
            <div key={col.title}>
              <p className="font-semibold text-foreground mb-2 uppercase tracking-wider text-[11px]">
                {col.title}
              </p>
              <ul className="space-y-1.5">
                {col.links.map((l) => (
                  <li key={l.href}>
                    <Link
                      href={l.href}
                      className="hover:text-foreground transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 border-t pt-6">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-primary text-primary-foreground flex items-center justify-center font-bold text-xs">
              O
            </div>
            <span className="font-semibold text-foreground">OneNext</span>
            <span>· {t("footer.copyright", { year: new Date().getFullYear() })}</span>
          </div>
          <p className="text-xs">
            {t("footer.tagline")}
          </p>
        </div>
      </div>
    </footer>
  );
}
